module.exports = __webpack_public_path__ + "img/486dcd6.jpg";